import { cn } from '@/lib/utils';

import { WithRef } from '@/components/types';

type DropdownProps = {
  children: React.ReactNode;
  detached?: boolean;
  classNames?: {
    wrapper?: string;
  };
} & React.HTMLAttributes<HTMLDivElement>;

export const Dropdown = ({
  children,
  classNames,
  detached = false,
  ref,
  ...rest
}: WithRef<HTMLDivElement, DropdownProps>) => {
  return (
    <div
      ref={ref}
      className={cn(
        'inline-block',
        !detached && 'relative',
        classNames?.wrapper
      )}
      data-tracker-component='dropdown'
      {...rest}
    >
      {children}
    </div>
  );
};

type DropdownMenuProps = {
  children: React.ReactNode;
  align?: 'left' | 'right';
  classNames?: {
    wrapper?: string;
    arrow?: string;
  };
} & React.HTMLAttributes<HTMLDivElement>;

export const DropdownMenu = ({
  children,
  classNames,
  align = 'left',
  ref,
  ...rest
}: WithRef<HTMLDivElement, DropdownMenuProps>) => {
  const alignClasses = {
    left: 'left-0',
    right: 'right-0',
  }[align];

  return (
    <div
      ref={ref}
      className={cn(
        'bg-neutral-N99 absolute z-20 mt-6 p-6',
        alignClasses,
        classNames?.wrapper
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
